import type { HsVector3 } from '../../math-new/objects/vector3.class';
import { HsBox } from '../../math-new/shapes/box.class';
import type { HsEmitter } from './emitter.interface';

export class HsBoxEmitter implements HsEmitter {
  public shape: HsBox;

  constructor(x0: number, y0: number, z0: number, x1: number, y1: number, z1: number) {
    this.shape = new HsBox(x0, y0, z0, x1, y1, z1);
  }

  public setCenter(x: number, y: number, z: number): void {
    const dx: number = this.shape.max.x - this.shape.min.x;
    const dy: number = this.shape.max.y - this.shape.min.y;
    const dz: number = this.shape.max.z - this.shape.min.z;
    this.shape.min.set(x - dx / 2, y - dy / 2, z - dz / 2);
    this.shape.max.set(x + dx / 2, y + dy / 2, z + dz / 2);
  }

  public getRandomPosition(target: HsVector3): HsVector3 {
    const x: number = Math.random() * (this.shape.max.x - this.shape.min.x) + this.shape.min.x;
    const y: number = Math.random() * (this.shape.max.y - this.shape.min.y) + this.shape.min.y;
    const z: number = Math.random() * (this.shape.max.z - this.shape.min.z) + this.shape.min.z;
    return target.set(x, y, z);
  }
}
